const pre = 'homepage';

export default [{
    path: '/homepage',
    name: `${pre}`,
    meta: {
        title: '主页',
        auth: ['monitor']
    },
    component: () =>
        import ('@/views/homepage')
}]
